import { render, staticRenderFns } from "./SignUpPrivacyLink.vue?vue&type=template&id=6e24584b"
import script from "./SignUpPrivacyLink.vue?vue&type=script&lang=js"
export * from "./SignUpPrivacyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports